const currentDate = new Date();
const dayOfWeek = currentDate.toLocaleDateString("en", { weekday: "short" });
const day = currentDate.getDate().toString().padStart(2, "0");
const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
const year = currentDate.getFullYear();

const dayMappings = {
  Mon: "T2",
  Tue: "T3",
  Wed: "T4",
  Thu: "T5",
  Fri: "T6",
  Sat: "T7",
  Sun: "CN",
};

const formattedDate = `${dayMappings[dayOfWeek]}-${day}/${month}/${year}`;
const timeString = currentDate.toTimeString().split(" ")[0];
const formatTiem = `${timeString}`;

const BillData = {
  idRoom: "",
  TotalTime: 0,
  PriceOfTotalTime: 0,
  OrderList: [],
  TotalPayment: 0,
  Debt: "",
  PriceOfTime: 0,
  Paymentime: formatTiem,
  Date: formattedDate,
  Brand: "EasyWay Karaoke",
  Address: "ĐC: Đường 53,Phường 14, Gò Vấp, Hồ Chí Minh",
  Phone: "0338.998.047",
  Line: "*************************************",
  Bill: "Hóa Đơn",
  Goodbye: "Karaoke EasyWay chân thành cảm ơn quý khách!",
  SubGoodbye: "Tạm biệt quý khách và hẹn gặp lại!",
};

export default BillData;
